<script>
  import { Router, Link, Route } from "svelte-routing";
  import { onMount } from "svelte";
  import List from "./list/list.html";
  import View from "./view/view.html";

function init() {
    console.log("redirecting ");
}
onMount(init);

</script>


<Router>
<Route path=":id" let:params>
    {#if params.id== "new"}
    <View id={null} />
    {:else}
    <View id={params.id} />
    {/if}
</Route>
<Route path="">
    <List />
</Route>
</Router>


